import { render, staticRenderFns } from "./provence.vue?vue&type=template&id=3480cdd7&scoped=true"
import script from "./provence.vue?vue&type=script&lang=js"
export * from "./provence.vue?vue&type=script&lang=js"
import style0 from "./provence.vue?vue&type=style&index=0&id=3480cdd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480cdd7",
  null
  
)

export default component.exports